import { Input, Modal } from '@arco-design/web-react';
import { authApi } from '@/api';

/**
 * 二次安全验证：用支付密码换取 step-up token
 */
export function requireStepUpToken(scenario: string, scenarioLabel: string): Promise<string> {
  return new Promise((resolve, reject) => {
    let pwd = '';
    Modal.confirm({
      title: '二次安全验证',
      content: (
        <div>
          <div style={{ marginBottom: 8, color: 'var(--up-color-text-tertiary)' }}>
            场景：{scenarioLabel}
          </div>
          <Input.Password
            placeholder="请输入支付密码"
            maxLength={32}
            onChange={(v) => {
              pwd = v;
            }}
          />
        </div>
      ),
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        if (!pwd) throw new Error('请输入支付密码');
        const { token } = await authApi.stepUp({ payPassword: pwd, scenario });
        resolve(token);
      },
      onCancel: () => reject(new Error('用户取消')),
    });
  });
}

/** @deprecated 使用 requireStepUpToken */
export function requireSecondaryAuth(scenarioLabel: string): Promise<string> {
  return requireStepUpToken('parent_wallet_transfer', scenarioLabel);
}
